import { Stack, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { type FC } from 'react';

import { type LiveVisionStage } from '../../api/index.js';

const STAGES: Array<{ value: LiveVisionStage; label: string; description: string }> = [
  { value: 'raw', label: 'Raw', description: 'The camera frame exactly as it arrives' },
  { value: 'preprocessed', label: 'Preprocessed', description: 'After preprocessing — exactly what YOLO receives' },
  { value: 'detection', label: 'Detection', description: 'Object boxes with class and confidence' },
  { value: 'pose', label: 'Pose', description: 'People with their 17-point skeletons' },
  { value: 'result', label: 'Result', description: 'Everything, plus zones, posture and the patient pick' },
];

interface Props {
  value: LiveVisionStage;
  onChange: (stage: LiveVisionStage) => void;
}

const VisionStageToggle: FC<Props> = ({ value, onChange }) => (
  <Stack spacing={0.5}>
    <Typography variant="overline" color="text.secondary">Stage</Typography>
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_event, stage: LiveVisionStage | null) => stage && onChange(stage)}
      sx={{ flexWrap: 'wrap' }}
    >
      {STAGES.map((stage) => (
        <Tooltip key={stage.value} title={stage.description}>
          <ToggleButton value={stage.value}>{stage.label}</ToggleButton>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  </Stack>
);

export default VisionStageToggle;
